import { IconHelpCircle, IconMail, IconNotes } from "@tabler/icons-react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PageHeader } from "@/components/page-header";
import { type Section, SectionLinks } from "@/components/section-links";

/** Content: the shop's pages, its frequently asked questions and the newsletter, each a page of its own. */
export const Route = createFileRoute("/_admin/content/")({
	component: ContentPage,
});

/** One line per content page. */
// biome-ignore format: one line per section, so parallel branches merge without touching each other's lines
const sections: readonly Section[] = [
	{ to: "/content/pages", icon: IconNotes, namespace: "page" },
	{ to: "/content/faq", icon: IconHelpCircle, namespace: "faqItem" },
	{ to: "/content/newsletter", icon: IconMail, namespace: "newsletter" },
];

function ContentPage() {
	const { t } = useTranslation("content");
	return (
		<div className="flex flex-col gap-6">
			<PageHeader title={t("title")} description={t("description")} />
			<SectionLinks sections={sections} />
		</div>
	);
}
